import React, { useState } from "react";

interface ProfileImageProps {
    src?: string | null;
    size?: number;
    fallbackIcon?: string;
    className?: string;
    border?: string;
}

const ProfileImage: React.FC<ProfileImageProps> = ({
    src,
    size = 40,
    fallbackIcon = "icon-profile",
    className = "",
    border,
}) => {
    const [imageError, setImageError] = useState(false);

    const baseStyle: React.CSSProperties = {
        width: size,
        height: size,
        borderRadius: "50%",
        flexShrink: 0,
    };

    // Show fallback if no src, image error, or empty string
    if (!src || imageError) {
        return (
            <div
                className={className}
                style={{
                    ...baseStyle,
                    backgroundColor: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: border,
                }}
            >
                <i className={`menu-img ${fallbackIcon}`} style={{ fontSize: size * 0.5 }} />
            </div>
        );
    }

    return (
        <img
            src={src}
            alt="Profile"
            className={className}
            style={{
                ...baseStyle,
                objectFit: "cover",
                border: border,
            }}
            onError={() => setImageError(true)}
        />
    );
};

export default ProfileImage;